module.exports = __webpack_public_path__ + "img/advanced-survery.d3d148f2.svg";